import { FormControl, FormControlLabel, InputLabel, useTheme } from '@mui/material'
import React, { FunctionComponent, KeyboardEventHandler, useEffect } from 'react'
import CreatableSelect from 'react-select/creatable'

import { MyInputLabel } from '../../../../base/components/MyInputs/MyInputLabel'
import { KeyValueProp } from '../../../../base/interfaces/base'
import { getSelectStyles } from '../../../../base/components/MySelect/selectStyles.tsx'

interface OwnProps {
  notas: KeyValueProp<string>[]
  onChange: (notas?: KeyValueProp<string>[]) => void
}

type Props = OwnProps

/**
 * Componente para agregar y eliminar notas rapidas
 * @param props
 * @constructor
 */
const TipoArticuloNotas: FunctionComponent<Props> = (props) => {
  const { notas, onChange } = props
  const [inputValue, setInputValue] = React.useState('')
  const [value, setValue] = React.useState<KeyValueProp<string>[]>([])

  const theme = useTheme()

  /**
   * Cuando se cambia el valor del input
   * @param event
   */
  const handleKeyDown: KeyboardEventHandler = (event) => {
    if (!inputValue) return
    switch (event.key) {
      case 'Enter':
      case 'Tab': {
        const v = [...value, { key: inputValue, value: inputValue }]
        setValue(v)
        setInputValue('')
        onChange(v)
        event.preventDefault()
      }
    }
  }
  useEffect(() => {
    setValue(notas)
  }, [])
  return (
    <FormControl fullWidth>
      <MyInputLabel shrink id="select-notas-rapidas">
        Notas Rápidas
      </MyInputLabel>
      <CreatableSelect
        components={{ DropdownIndicator: null }}
        styles={getSelectStyles(theme, false)}
        inputValue={inputValue}
        isClearable
        isMulti
        menuIsOpen={false}
        onChange={(newValue: any) => {
          setValue(newValue)
          onChange(newValue)
        }}
        onInputChange={(newValue) => setInputValue(newValue)}
        onKeyDown={handleKeyDown}
        placeholder="Escriba y presione enter o tab..."
        value={value}
        formatOptionLabel={(option) => (option ? `${option.value || ''}` : '')}
        getOptionValue={(option) => option.value}
      />
    </FormControl>
  )
}

export default TipoArticuloNotas
